export default "__VITE_ASSET__Dwfx9NJc__"